package com.essntl.features.country.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.country.domain.usecase")
class AddEditCountryUseCaseModule